<template>

    <cart-index
        :cart="getCart"
        :changes="changes"
    ></cart-index>

</template>

<script>

import CartIndex from "./Index.vue";
import { mapGetters } from "vuex";
import Layout from "../../../Shared/Layout.vue";

export default {

    components: {
        CartIndex,
    },

    computed: {
        ...mapGetters([
            'getCart',
        ]),
    },

    layout:Layout,

    props: {
        changes:{
            type:Object,
            default:() => {},
        },
    },

}

</script>
